import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MbApi_DestinationsDelete, MbApi_DestinationsList } from "../../mb_api/mb_api_destinations";
import { MbBackdrop } from "../../mb_components/mb_backdrop";
import { MbMessage } from "../../mb_components/mb_message";
import { RecordsForPage } from "../../mb_constants";
import { MbTable } from "../../mb_table/mb_table";
import { MbProposeColumns, MbSaveColumnsForTable } from "../../mb_table/mb_table_api";
import { MbAnagraficaNewDestinations } from "../mb_anagrafica_new_destinations";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const MbAnagraficaDestinations = ({id_customer_supplier, isValidator, callbackFromValidator}) => {

    const params                                = useParams();
    const [page, setPage]                       = useState(0);
    const [data, setData]                       = useState([]);
    const [records, setRecords]                 = useState(-1);
    const [displayNew, setDisplayNew]           = useState(false);
    const [search, setSearch]                   = useState(null);
    const [structUpdate, setStructUpdate]       = useState(null);
    const [displayBackdrop, setDisplayBackdrop] = useState(false);
    const [displayMessage, setDisplayMessage]   = useState(false);
    const navigate                              = useNavigate();

    function fetchData(){
        MbApi_DestinationsList(page, search, id_customer_supplier ? id_customer_supplier : params['id_customer_supplier']).then((response) => {
            if(response.Result == "OK"){
                setRecords(response.Json.count);
                const items = [];
                if(response.Json.count > 0){
                    response.Json.destinationss.map((item, index) => 
                        items.push([item.id, item.code, item.description, item.collective, item.address, item.zip_code, item.province, item.house_number, item.country_code, item.default == 1 ? <CheckIcon sx={{color: "green"}}/> : <CloseIcon sx={{color: "red"}}/>, item.default, item])
                    )
                }
                setData(items);
            }
        });
    }

    useEffect(() => {
        if(page == -1){
            setPage(0);
            return;
        }
        fetchData();
    }, [page]);
    
    function eHashChange(){
        const _displayNew = window.location.hash.includes('new') && !displayNew;
        setDisplayNew(_displayNew);
        if(!_displayNew){
            setStructUpdate(null);
        }
    }

    useEffect(() => {
        
        MbSaveColumnsForTable("destinazioni", ["ID", "Codice", "Descrizione", "Comune", "Indirizzo", "Provincia", "CAP", "Numero civico", "Nazione", "Predefinita"]);

        window.addEventListener('hashchange', eHashChange);

        return (() => {
            try{
                window.removeEventListener('hashchange', eHashChange);
            }catch(_){}
        });

    }, []);

    return (
        <>  
            <MbMessage open={displayMessage} close={() => setDisplayMessage(null)} message={displayMessage} />
            <MbBackdrop display={displayBackdrop}/>
            {
                displayNew ? 
                    <MbAnagraficaNewDestinations
                        id_customer={params['id_customer_supplier']}
                        comeback={() => {
                            setPage(-1);
                            setStructUpdate(null);
                            //navigate(-1);
                        }}
                        structure={structUpdate}
                    />
                :
                    <MbTable
                        isValidator={isValidator}
                        table={"destinazioni"}
                        columns={
                            MbProposeColumns(
                                'destinazioni',
                                [
					                {"name": "ID"}, 
                                    {"name": "Codice"}, 
                                    {"name": "Descrizione"}, 
                                    {"name": "Comune"}, 
                                    {"name": "Indirizzo"}, 
                                    {"name": "CAP"}, 
                                    {"name": "Provincia"}, 
                                    {"name": "Numero civico"}, 
                                    {"name": "Nazione"},
                                    {"name": "Predefinita"}
                                ]
                            )
                        }
                        rows={[...data]}
                        displayDelete
                        displayNew
                        displayRead
                        displayUpdate
                        recordForPage={RecordsForPage}
                        totalRecords={records}
                        page={page}
                        pageChange={(page) => {
                            setPage(page - 1);
                        }}
                        changedRecordForPage={() => {
                            if(page == 0){
                                setPage(-1);
                            }else{
                                setPage(0);
                            }
                        }}
                        changedColumnsTable={() => {
                            setPage(-1);
                        }}
                        searchEventOutside={(value) => {
                            setPage(-1);
                            setSearch(value);
                        }}
                        clickUpdate={(data) => {
                            let copy = [...data];
                            copy[copy.length - 2] = copy[copy.length - 1];
                            setStructUpdate(copy);
                            window.location.hash = '#new';
                        }}
                        deleteEvent={(data) => {
                            setDisplayBackdrop(true);
                            setTimeout(async () => {
                                const deleted = await MbApi_DestinationsDelete(data[0]);
                                setDisplayBackdrop(false);
                                if(deleted){
                                    setPage(-1);
                                }
                                setDisplayMessage(deleted ? "Record cancellato con successo!" : "Errore durante la cancellazione del record!");
                            }, 1000);   
                        }}
                        clickRow={(data) => {
                            if(isValidator){
                                callbackFromValidator(data);
                            }
                        }}
                        displayRecordForPage
                        displaySetting
                        clickNew={() => window.location.hash = "#new" }
                        key="TABLE_DESTINAZIONI"
                    />
            }
        </>
    );

};

export {
    MbAnagraficaDestinations
}